import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
} from '@mui/material';

// Sample mock data
const mockBookings = [
  {
    id: 1,
    guestName: 'John Doe',
    contact: '012345678',
    roomNumber: '',
    date: '2025-08-06',
    time: '19:00',
    guests: 2,
    status: 'confirmed',
    notes: 'Birthday dinner'
  },
  {
    id: 2,
    guestName: 'Jane Smith',
    contact: '098765432',
    roomNumber: '',
    date: '2025-08-07',
    time: '18:30',
    guests: 4,
    status: 'pending',
    notes: ''
  }
];

export default function RestaurantBooking() {
  const [open, setOpen] = useState(false);
  const [bookings, setBookings] = useState(mockBookings);
  const [form, setForm] = useState({
    guestName: '',
    contact: '',
    roomNumber: '',
    date: '',
    time: '',
    guests: '',
    status: 'pending',
    notes: ''
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    setBookings([...bookings, { ...form, id: Date.now() }]);
    setForm({
      guestName: '',
      contact: '',
      roomNumber: '',
      date: '',
      time: '',
      guests: '',
      status: 'pending',
      notes: ''
    });
    setOpen(false);
  };

  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>
        Room Service Bookings
      </Typography>
      <Button variant="contained" color="primary" onClick={() => setOpen(true)}>
        Add Booking
      </Button>
      <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Guest</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Time</TableCell>
              <TableCell>Guests</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Contact</TableCell>
              <TableCell>Room</TableCell>
              <TableCell>Notes</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {bookings.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.guestName}</TableCell>
                <TableCell>{row.date}</TableCell>
                <TableCell>{row.time}</TableCell>
                <TableCell>{row.guests}</TableCell>
                <TableCell>{row.status}</TableCell>
                <TableCell>{row.contact}</TableCell>
                <TableCell>{row.roomNumber}</TableCell>
                <TableCell>{row.notes}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
        <DialogTitle>Add Booking</DialogTitle>
        <DialogContent dividers>
          <TextField
            margin="dense"
            label="Guest Name"
            name="guestName"
            fullWidth
            value={form.guestName}
            onChange={handleChange}
          />
          <TextField
            margin="dense"
            label="Contact"
            name="contact"
            fullWidth
            value={form.contact}
            onChange={handleChange}
          />
          <TextField
            margin="dense"
            label="Room Number"
            name="roomNumber"
            fullWidth
            value={form.roomNumber}
            onChange={handleChange}
          />
          <TextField
            margin="dense"
            label="Date"
            type="date"
            name="date"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={form.date}
            onChange={handleChange}
          />
          <TextField
            margin="dense"
            label="Time"
            type="time"
            name="time"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={form.time}
            onChange={handleChange}
          />
          <TextField
            margin="dense"
            label="Guests"
            name="guests"
            type="number"
            fullWidth
            value={form.guests}
            onChange={handleChange}
          />
          <TextField
            margin="dense"
            label="Status"
            name="status"
            fullWidth
            select
            value={form.status}
            onChange={handleChange}
          >
            <MenuItem value="pending">Pending</MenuItem>
            <MenuItem value="confirmed">Confirmed</MenuItem>
            <MenuItem value="cancelled">Cancelled</MenuItem>
            <MenuItem value="completed">Completed</MenuItem>
          </TextField>
          <TextField
            margin="dense"
            label="Notes"
            name="notes"
            fullWidth
            value={form.notes}
            onChange={handleChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button onClick={handleSubmit} variant="contained" color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}